import { Label, Spinner, Stack, Text } from '@fluentui/react';
import { useEffect, useState } from 'react';

import taxAdmins from '../../../../../shared/tax-admins.json';
import { getAsync } from '../../../../../utils/api';

type Props = { accountId: string; accountVersionId: string };

export default (props: Props) => {
  const [accountData, setAccountData] = useState<any>();

  useEffect(() => {
    getAsync(
      `/accounts/get?id=${props.accountId}&versionId=${props.accountVersionId}`
    ).then((result) => {
      if (!result.success) {
        alert("Müşteri bilgileri yüklenirken hata oluştu");
        return;
      }

      setAccountData(result.data);
    });
  }, [props.accountId, props.accountVersionId]);

  if (!accountData) return <Spinner />;

  return (
    <Stack wrap horizontal tokens={{ childrenGap: 15 }}>
      {accountDataParsers.map((parser) => {
        const value = accountData[parser.key];

        return (
          <Stack.Item key={parser.key} style={{ width: "calc(25% - 15px)" }}>
            <Label>{parser.label}</Label>
            <Text>
              {!value
                ? "—"
                : parser.transform
                ? parser.transform(value)
                : value}
            </Text>
          </Stack.Item>
        );
      })}
    </Stack>
  );
};

const accountDataParsers = [
  { key: "name", label: "Hesap Adı" },
  { key: "companyName", label: "Şirket Ünvanı" },
  { key: "citizenId", label: "VKN / TCKN" },
  {
    key: "taxAdminId",
    label: "Vergi Dairesi",
    transform: (id: string) => taxAdmins.find((i) => i.id === id)?.name,
  },
  { key: "email", label: "E-Mail Adresi" },
  {
    key: "phones",
    label: "İrtibat Numaraları",
    transform: (phones: string[]) => phones.join(", "),
  },
  { key: "shipmentAddress", label: "Teslim Adresi" },
  { key: "invoiceAddress", label: "Fatura Adresi" },
];
